module.exports = __webpack_public_path__ + "img/ic_scene_top.22f2086a.png";